export default __webpack_public_path__ + "static/media/icon-activity-created.0a0f76b9.svg";